import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import StartGameButton from './Components/Start';
import Game from './Components/Game';
import DeveloperPage from './Components/Developer';
import Footer from './Components/Footer';

export default function App() {
  return (
    
    <Router>
        <Routes>
          <Route path="/" exact element={<StartGameButton />} />
          <Route path="/game" exact element={<Game />} />
          <Route path="/dev-info" exact element={<DeveloperPage />} />
        </Routes>
	<Footer />
    </Router>
    
  );
}
